module.exports = __webpack_public_path__ + "static/media/luohanshan_web.8d7e7b68.webp";